export const PANEL_BASE = '/panel';

export function panelPath(path: string): string {
  const trimmed = path.startsWith('/') ? path : `/${path}`;
  return `${PANEL_BASE}${trimmed === '/' ? '' : trimmed}`;
}
